module.exports = __webpack_public_path__ + "img/40_29_770_060.8f46157f.jpg";